export default __webpack_public_path__ + "static/media/expand-your-reach-banner.4e8d8446.webp";